import { ServicePointOrdersServiceMock } from "./servicePoint.types";

export const mockServicePointOrdersService = (): ServicePointOrdersServiceMock => ({
  fetchServicePoints: jest.fn(),
});
